// src/pages/ErrorPago.js
import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Avatar, Button, Grid } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate, useParams } from 'react-router-dom';
import { api as apiUser } from "../api";
import { api } from "./api"; 



const ErrorPago = () => {
  const navigate = useNavigate();
    const { internalId } = useParams();
  const [pago, setPago] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

useEffect(() => {
  const loginAndFetch = async () => {
    try {
      const data = await apiUser.usuario.getUsuarioByInternalId(internalId);
      setUser(data.user);
      console.log("DATOS DEL USER: ", data)
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);
      const res = await api.pagos.getPagoByInternalId(internalId); 
      setPago(res);
      console.log("DATOS DEL PAGO: ", res)
    } catch (err) {
        console.error("Error detallado: ", err);
      setError("Error al traer los datos de pago o usuario");
    } finally {
      setLoading(false);
    }
  };

  loginAndFetch();
}, [internalId]);


  return (
    <Box p={2} maxWidth={600} mx="auto" textAlign="center">
      <Card sx={{ p: 4, borderRadius: 3, boxShadow: 4, mb: 4 }}>
        <Avatar sx={{ bgcolor: 'error.main', mx: 'auto', mb: 2, width: 60, height: 60 }}>
          <ErrorOutlineIcon sx={{ fontSize: 40 }} />
        </Avatar>
        <Typography variant="h5" fontWeight="bold" mb={1}>
          {pago.message}
        </Typography>
        <Typography variant="subtitle1" mb={3} color="text.secondary">
          Disculpanos {user.nombre}. Tuvimos un error al procesar tu pago.
        </Typography>
                <Typography variant="subtitle2" mb={3} color="text.secondary">
          Comunicate con nosotros al 3482-xxxxxx por dudas o consultas.
        </Typography>

        <Button
          variant="contained"
          color="error"
          onClick={() => navigate('/dashboard')}
          sx={{ mt: 2 }}
        >
          Volver al Dashboard
        </Button>
      </Card>
    </Box>
  );
};

export default ErrorPago;
